import { TIMELINE } from "@/data/siteData";

export default function Timeline() {
  return (
    <section className="relative py-24 md:py-32 bg-white">
      <div className="max-w-6xl mx-auto px-6 md:px-10">
        <div className="max-w-2xl">
          <p className="overline">Come funziona la visita</p>
          <h2 className="font-serif text-4xl md:text-5xl mt-4 text-[#0B4A5A] tracking-tight">
            Un percorso in quattro tempi.
          </h2>
        </div>

        <div className="mt-16 relative pl-2 md:pl-8">
          <div className="timeline-line" />
          <ol className="space-y-10">
            {TIMELINE.map((step, i) => (
              <li key={step.title} className="relative pl-14">
                <div className="absolute left-0 top-0 w-10 h-10 rounded-full bg-white border border-[#C6A86B] text-[#0B4A5A] font-serif text-lg flex items-center justify-center shadow-[0_4px_18px_rgba(198,168,107,0.15)]">
                  {i + 1}
                </div>
                <h3 className="font-serif text-2xl text-[#0B4A5A]">
                  {step.title}
                </h3>
                <p className="mt-2 text-gray-600 leading-relaxed max-w-2xl">
                  {step.desc}
                </p>
              </li>
            ))}
          </ol>
        </div>
      </div>
    </section>
  );
}
